import { useQuery } from 'react-query';

import { communityApi } from 'src/Services/API';

const useFetchAllMembers = () => {
  const { data, isLoading } = useQuery({
    queryKey: ['fetch-all-members'],
    queryFn: async () => {
      return (await communityApi.communityControllerMembers()).data;
    },
    staleTime: 5 * 60 * 1000,
    cacheTime: 10 * 60 * 1000,
  });

  return {
    data: { members: data?.members ?? [] },
    isLoading,
  };
};

export default useFetchAllMembers;
